import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AiAgentsService, AiConnectionScope, AiModelConnection } from '../../../core/services/ai-agents';

@Component({
  selector: 'app-ai-model-connections-page',
  standalone: false,
  templateUrl: './ai-model-connections-page.html',
  styleUrl: './ai-model-connections-page.scss',
})
export class AiModelConnectionsPage implements OnInit {
  @Input({ required: true }) scope: AiConnectionScope = 'personal';
  @Input() embedded = false;
  records: AiModelConnection[] = [];
  editing: AiModelConnection | null = null;
  detailOpen = false;
  helpOpen = false;
  loading = false;
  actionId = '';
  error = '';
  activeTab: 'connection' | 'models' = 'connection';
  models: string[] = [];
  loadingModels = false;

  constructor(private readonly api: AiAgentsService, private readonly cdr: ChangeDetectorRef) {}
  ngOnInit(): void { void this.load(); }

  get scopeLabel(): string { return this.scope === 'organisation' ? 'Organisation' : 'Personal'; }
  get description(): string { return this.scope === 'organisation' ? 'Shared connections preferred for organisation data.' : 'Private fallback connections used when the organisation has no active model.'; }

  async load(): Promise<void> {
    this.loading = true; this.error = '';
    try { this.records = await firstValueFrom(this.api.listConnections(this.scope)); }
    catch { this.error = `Could not load ${this.scope} AI model connections.`; }
    finally { this.loading = false; this.cdr.detectChanges(); }
  }

  open(record: AiModelConnection | null = null): void {
    this.editing = record; this.detailOpen = true; this.activeTab = 'connection'; this.models = [];
    this.cdr.detectChanges();
  }
  close(): void { this.detailOpen = false; this.editing = null; this.models = []; this.cdr.detectChanges(); }
  async saved(record: AiModelConnection): Promise<void> { this.editing = record; await this.load(); await this.showModels(); }

  async showModels(): Promise<void> {
    this.activeTab = 'models';
    if (!this.editing || this.models.length) return;
    this.loadingModels = true; this.error = '';
    try { this.models = (await firstValueFrom(this.api.connectionModels(this.editing.id))).models; }
    catch (error: any) { this.error = error?.error?.message || error?.message || 'Could not fetch available models.'; }
    finally { this.loadingModels = false; this.cdr.detectChanges(); }
  }

  async test(record: AiModelConnection): Promise<void> {
    this.actionId = record.id; this.error = '';
    try { await firstValueFrom(this.api.testConnection(this.scope, record.id)); await this.load(); }
    catch (error: any) { this.error = error?.error?.message || error?.message || 'The connection test could not be completed.'; }
    finally { this.actionId = ''; this.cdr.detectChanges(); }
  }

  async remove(record: AiModelConnection): Promise<void> {
    if (!confirm(`Delete ${record.name}?`)) return;
    this.actionId = record.id;
    try { await firstValueFrom(this.api.deleteConnection(this.scope, record.id)); await this.load(); }
    catch { this.error = 'Could not delete this connection.'; }
    finally { this.actionId = ''; this.cdr.detectChanges(); }
  }
}
